import { BOARD_TEXT_LINE_HEIGHT } from '../constants/whiteboard-config.constants.js';

// Legacy stub — migrate consumers to slice files in PRD-H.
// Renderer logic lives in `src/features/*` (dispatched via ObjectRegistry).
// This file only re-exports constants/helpers still imported cross-module.
export {
  STICKY_PADDING, stickyPaddingFor, STICKY_FONT_FAMILY,
  STICKY_FONT_MIN, STICKY_FONT_MAX, STICKY_LINE_HEIGHT, computeStickyFontSize,
} from '../features/sticky/sticky.renderer.js';
export { CHECKBOX_NAME, CHECKBOX_CHECK_NAME } from '../features/checkbox/checkbox.renderer.js';
export { PERSON_ICON_RATIO, PERSON_FONT_SIZE, PERSON_NAME_TEXT } from '../features/person/person.renderer.js';

/** Checklist hotspot line height — the board-wide text line height (was 1.25). */
export const TEXTBOX_LINE_HEIGHT = BOARD_TEXT_LINE_HEIGHT;

/** Strip HTML tags so rich-text can be rendered in a Konva.Text node. */
export function stripHtml(html: string): string {
  if (!html) return '';
  return html
    .replace(/<div[^>]*>/gi, '\n').replace(/<\/div>/gi, '')
    .replace(/<p[^>]*>/gi, '\n').replace(/<\/p>/gi, '')
    .replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>').replace(/&amp;/g, '&')
    .replace(/^\n+/, '').replace(/\n+$/, '');
}
